import instance from './AxiosServices';

const AuthService = {
  login: async (email, password, phone, otp) => {
    const data = await instance.post('/admin/login', { email, password, phone, otp, isPartner: true, client: 'partner' });
    if (data && data.token) {
      localStorage.setItem('partner_token', data.token);
      localStorage.setItem('partner_user', JSON.stringify(data));
    }
    return data;
  },

  checkPartner: async (phone) => {
    const data = await instance.post('/admin/check-partner', { phone });
    return data;
  },

  registerPartner: async (partnerData) => {
    const data = await instance.post('/admin/register-partner', partnerData);
    if (data && data.token) {
      localStorage.setItem('partner_token', data.token);
      localStorage.setItem('partner_user', JSON.stringify(data));
    }
    return data;
  },

  getPartnerProfile: async () => {
    const data = await instance.get('/admin/partner-profile');
    return data;
  },

  updatePartnerProfile: async (profileData) => {
    const data = await instance.put('/admin/partner-profile', profileData);
    return data;
  },

  logout: () => {
    localStorage.removeItem('partner_token');
    localStorage.removeItem('partner_user');
    window.location.href = '/login';
  },

  getCurrentUser: () => {
    try {
      const userStr = localStorage.getItem('partner_user');
      return userStr ? JSON.parse(userStr) : null;
    } catch (e) {
      return null;
    }
  },

  isAuthenticated: () => {
    const token = localStorage.getItem('partner_token');
    return !!token;
  }
};

export default AuthService;
